import { makeStyles } from '@material-ui/core';

const styles = makeStyles((_theme) => ({
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
  },
  closeBnt: {
    width: 35,
    height: 35,
    alignSelf: 'flex-end',
    textTransform: 'none',
  },
  backBnt: {
    textTransform: 'none',
  },
  box: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  inputStyle: {
    marginTop: 10,
  },
  mandatory: {
    color: 'red',
    marginLeft: 5,
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0 15px',
    textTransform: 'uppercase',
  },
}));

export default styles;
